import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';

const initialState = {
  siteKey: '',
};

export const siteKeySelector = state => state.hcaptcha.siteKey;

export const fetchSiteKey = createAsyncThunk(
  'hcaptcha/fetchSiteKey',
  async (_, thunkAPI) => {
    try {
      return (await axios.get('/h')).data;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  },
);

export const slice = createSlice({
  name: 'hcaptcha',
  initialState,
  reducers: {},
  extraReducers: {
    [fetchSiteKey.fulfilled]: (state, action) => {
      state.siteKey = action.payload.s;
    },
  },
});

export default slice.reducer;
